import { get } from "svelte/store";
import { accessTokenStore } from "../../../stores";
import type { TPaymentReturn } from "@packages/utils/types";

export const getOrderDetails = async (apiUrl: string, orderId: string, maxRetries = 10): Promise<TPaymentReturn> => {
  let attempts = 0;
  
  while (attempts < maxRetries) {
    const res = await fetch(`${apiUrl}/orders/${orderId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${get(accessTokenStore)}`,
      },
      method: "GET",
    });
    
    if (!res.ok) throw new Error("Failed to get order details");
    
    const orderData = await res.json();
    
    // If status is not NEW, return the data
    if (orderData.status !== 'NEW') {
      return orderData;
    }
    
    // If status is NEW, wait and retry
    attempts++;
    if (attempts < maxRetries) {
      // Wait 2 seconds before retrying
      await new Promise(resolve => setTimeout(resolve, 2000));
    }
  }
  
  // If we've exceeded max retries, throw an error
  throw new Error(`Order attempts exceeded. Please try again later.`);
}
export const getCompmletedOrderDetails = async (
  apiUrl: string,
  orderId: string,
  maxRetries = 5
) => {
  let attempts = 0;

  while (attempts < maxRetries) {
    const res = await fetch(`${apiUrl}/orders/completed/${orderId}`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${get(accessTokenStore)}`,
      },
      method: "GET",
    });

    if (res.status === 204) {
      attempts++;
      if (attempts < maxRetries) {
        continue;
      } else {
        throw new Error("No content received after multiple attempts");
      }
    }

    if (!res.ok) throw new Error("Failed to get order details");
    return await res.json();
  }
};


export const validateTxs = (txs: string[] | null[], message: string) => {
  if (txs.every((item) => item === null)) {
    throw new Error(`All transactions failed. \n${message}`);
  }
}

export const validateOrderItems = (
  orders: TPaymentReturn["items"],
): string => {
  const errorMessages = orders
    .filter((item) => item.error)
    .map(
      (item) =>
        `Name: ${item.metadata?.name || item.directive.resource_id}, reason: ${item.error}`
    )
    .join("\n");
  if (orders?.every(item => item.status === "ERROR")) {
    throw new Error(`All transactions failed.}`);
  }
  return errorMessages;
};
